import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeaderUser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19.256,
	viewBox: "0 0 19 19.256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "person_FILL1_wght600_GRAD0_opsz48",
		d: "M16.786,16.494a4.474,4.474,0,0,1-4.658-4.658A4.476,4.476,0,0,1,16.786,7.15a4.5,4.5,0,0,1,4.686,4.686,4.511,4.511,0,0,1-1.321,3.351A4.585,4.585,0,0,1,16.786,16.494ZM7.3,26.406v-3.1a3.492,3.492,0,0,1,.6-2.031,3.853,3.853,0,0,1,1.562-1.321,20.39,20.39,0,0,1,3.721-1.306,15.521,15.521,0,0,1,3.607-.426,14.988,14.988,0,0,1,3.621.44,21.97,21.97,0,0,1,3.678,1.292,3.711,3.711,0,0,1,1.6,1.292A3.482,3.482,0,0,1,26.3,23.31v3.1Z",
		transform: "translate(-7.3 -7.15)",
		fill: "#ffffff"
	})
});
export { SvgHeaderUser as ReactComponent };
